<template>
  <svg class="logo" width="37" height="37" viewBox="0 0 37 37" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M33.653 0H3.34695C1.4985 0 0 1.4985 0 3.34695V33.653C0 35.5015 1.4985 37 3.34695 37H33.653C35.5015 37 37 35.5015 37 33.653V3.34695C37 1.4985 35.5015 0 33.653 0ZM11.4494 31.9482C11.4494 32.4862 11.0133 32.9222 10.4754 32.9222H6.32923C5.79127 32.9222 5.35522 32.4862 5.35522 31.9482V14.5678C5.35522 14.0299 5.79127 13.5938 6.32923 13.5938H10.4754C11.0133 13.5938 11.4494 14.0299 11.4494 14.5678V31.9482ZM8.40229 11.9555C6.22694 11.9555 4.46344 10.1919 4.46344 8.0166C4.46344 5.84125 6.22694 4.07775 8.40229 4.07775C10.5776 4.07775 12.3411 5.84125 12.3411 8.0166C12.3411 10.1919 10.5777 11.9555 8.40229 11.9555ZM33.1169 32.0267C33.1169 32.5213 32.7159 32.9222 32.2214 32.9222H27.7723C27.2777 32.9222 26.8767 32.5213 26.8767 32.0267V23.8743C26.8767 22.6581 27.2335 18.545 23.6985 18.545C20.9565 18.545 20.4004 21.3603 20.2887 22.6238V32.0267C20.2887 32.5213 19.8878 32.9222 19.3931 32.9222H15.0901C14.5955 32.9222 14.1945 32.5213 14.1945 32.0267V14.4894C14.1945 13.9948 14.5955 13.5938 15.0901 13.5938H19.3931C19.8877 13.5938 20.2887 13.9948 20.2887 14.4894V16.0057C21.3054 14.4799 22.8164 13.3022 26.0336 13.3022C33.1577 13.3022 33.1169 19.9579 33.1169 23.6149V32.0267Z" fill="black"/>
</svg>

</template>

<script>
export default {
  name: 'linkedin-icon'
}
</script>

<style>
.logo {
  fill: currentColor
}
</style>